import { render } from "./index.vue?vue&type=template&id=c1494f0a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=c1494f0a&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1494f0a"]])

export default __exports__